import { Close, Search } from "@mui/icons-material";
import {
  FormHelperText,
  FormLabel,
  IconButton,
  Input,
  InputAdornment,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { Fragment } from "react";

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  marginBottom: "0.25rem",

  "& .MuiFormLabel-asterisk": {
    color: theme.palette.error.main
  }
}));

const StyledInput = styled(Input)(() => ({
  width: "100%",
  height: "50px",
  borderRadius: "6px",
  border: "1px solid rgba(0, 0, 0, 0.23)",

  "&.MuiInputBase-adornedStart": {
    paddingLeft: "8px"
  },

  "&.MuiInputBase-root:before, &.MuiInputBase-root.MuiInput-focused:before": {
    borderBottom: "none"
  },

  "&.MuiInputBase-root:after": {
    borderBottom: "none"
  },

  "&.MuiInputBase-root:hover:before": {
    borderBottom: "none"
  },

  "&.MuiInputBase-root:hover:after": {
    borderBottom: "none"
  }
}));

export const SearchInput = ({
  placeholder,
  label = "",
  onChange,
  ...props
}: {
  placeholder: string;
  label?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
  required: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  InputProps?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  error?: any;
  clearable?: boolean;
  onClearClick?: () => void;
}) => {
  return (
    <Fragment>
      {label && (
        <StyledFormLabel required={props.required}>
          <Typography display="inline" variant="formLabel">
            {label}
          </Typography>
        </StyledFormLabel>
      )}
      <StyledInput
        {...props.InputProps}
        {...props}
        placeholder={placeholder}
        className="search-input"
        onChange={onChange}
        onBlur={props.onBlur || props.InputProps?.onBlur}
        startAdornment={
          <InputAdornment position="start">
            <Search />
          </InputAdornment>
        }
        endAdornment={
          props.clearable ? (
            <IconButton
              onClick={() => {
                if (props.onClearClick) props.onClearClick();
              }}
            >
              <Close />
            </IconButton>
          ) : undefined
        }
      />
      {props.error && (
        <FormHelperText error={!!props.error}>
          {props.error?.message}
        </FormHelperText>
      )}
    </Fragment>
  );
};
